export default function BackToTop({ visible }: { visible: boolean }) {
  if (!visible) return null;
  return (
    <button
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      aria-label="返回顶部"
      className="fixed bottom-6 right-5 z-40 flex h-11 w-11 items-center justify-center rounded-full bg-primary-500 text-background-50 shadow-lg transition-all hover:bg-primary-600 md:bottom-8 md:right-7"
    >
      <i className="ri-arrow-up-line text-xl"></i>
    </button>
  );
}